(function($) {
    // placeholder attribute polyfill
    if (!('placeholder' in document.createElement('input'))) {
        $("input[placeholder]")
            .focus(
                function() {
                    if ($(this).val() == $(this).attr("placeholder")) $(this).val("");
                })
            .blur(
                function() {
                    if ($(this).val() == "")
                        $(this).val($(this).attr("placeholder"));
                })
            .blur();
        // prevent posting faux placeholder with form
        $("form:has(input[placeholder])").submit(function() {
            var placeholderInputs = $("input[placeholder]");
            placeholderInputs.each(function() {
                if ($(this).attr("value") == $(this).attr("placeholder")) {
                    $(this).attr("value", "");
                }
            });
        });
    }
    // textarea[maxlength] polyfill
    if (!('maxLength' in document.createElement('textarea'))) {
        $('textarea[maxlength]').bind('keydown paste keyup change', function(e) {
            var limit = parseInt($(this).attr('maxlength')),
                text = $(this).val(),
                chars = text.length,
                exceeded = chars >= limit,
                diff = limit - chars,
                code = e.keyCode;

            if (!exceeded) {
                return true;
            }

            if (e.type == "keydown") {
                switch (code) {
                case 8:
                case 9:
                case 17:
                case 36:
                case 35:
                case 37:
                case 38:
                case 39:
                case 40:
                case 46:
                case 65:
                    return true;
                default:
                    e.preventDefault();
                    return code != 32 && code != 13 && chars == limit;
                }
            }

            if (diff < 0) {
                $(this).val(text.substr(0, limit));
            }

            return true;
        });
    }
})(jQuery);